import React, { useContext, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Stack,
  useMediaQuery,
} from "@mui/material";
import logo from "../../images/stake-image.png";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { styled } from "@mui/material/styles";
import { LightTooltip } from "./Staking";
import { AppContext } from "../../utils";
import Loader from "../../loading";
import {
  useGalaxyContractWeb3,
  useGalaxyTokenContract,
  useStakingContract,
  useStakingContractWeb3,
} from "../../ConnectivityAss/hooks";
import { toast } from "react-toastify";
import { stakingAddress } from "../../utils/environment";
import { formatUnits, parseUnits } from "@ethersproject/units";

// Accordian

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `0px solid ${theme.palette.divider}`,
  backgroundColor: "transparent",
  borderBottom: 0,

  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.9rem", color: "#fff" }} />}
    {...props}
  />
))(({ theme }) => ({
  color: "#fff",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));
export default function AccordionStake() {
  const matches = useMediaQuery("(max-width:750px)");

  const { account, signer } = useContext(AppContext);
  const stakingContract = useStakingContract(signer);
  const stakingContractWeb3 = useStakingContractWeb3();
  const galaxyContract = useGalaxyTokenContract(signer);
  const galaxyContractWeb3 = useGalaxyContractWeb3();

  const [index, setindex] = useState(0);

  const [loading, setloading] = useState(false);
  const [amount, setamount] = useState("");
  const [decimals, setdecimals] = useState("");
  const [balance, setbalance] = useState(0);
  const [totalStakedAmount, settotalStakedAmount] = useState(0);
  const [unstake, setunstake] = useState(false);
  const [withdraw, setwithdraw] = useState(false);
  const [currentTire, setcurrentTire] = useState(0);
  const [stakeCount, setstakeCount] = useState(0);

  const init = async () => {
    const decimals = await galaxyContractWeb3.methods.decimals().call();
    setdecimals(decimals);
    const balance = await galaxyContractWeb3.methods.balanceOf(account).call();
    setbalance(formatUnits(balance, decimals));
    const totalStaked = await stakingContractWeb3.methods
      .Stakers(account)
      .call();
    settotalStakedAmount(formatUnits(totalStaked[0], decimals));
    setcurrentTire(totalStaked[1]);
    setstakeCount(totalStaked[2]);
    setunstake(totalStaked[3]);
    setwithdraw(totalStaked[5]);
  };
  useEffect(() => {
    if (account) {
      init();
    }
  }, [account]);

  const stakeHandler = async () => {
    if (!account) {
      toast.error("Please connect your wallet");
    } else {
      if (!amount) {
        toast.error("Error! please enter amount");
      } else if (isNaN(+amount) || +amount < 0) {
        toast.error("Error! Please enter a valid amount");
      } else {
        try {
          setloading(true);
          let tx = await galaxyContract.approve(
            stakingAddress,
            parseUnits(amount, decimals)
          );
          await tx.wait();
          let tx1 = await stakingContract.stake(parseUnits(amount, decimals));
          await tx1.wait();
          toast.success("Success! Transaction confirmed.");
          setloading(false);
          init();
        } catch (error) {
          if (error?.data?.message) {
            toast.error(error?.data?.message);
          } else {
            toast.error(error?.message);
          }

          setloading(false);
        }
      }
    }
  };
  const unStakeHandler = async () => {
    if (!account) {
      toast.error("Error! please connect your wallet");
    } else {
      try {
        setloading(true);
        let tx = await stakingContract.unstake();
        await tx.wait();
        toast.success("Success! Transection completed. ");
        setloading(false);
      } catch (error) {
        setloading(false);
        if (error?.data?.message) {
          toast.error(error?.data?.message);
        } else {
          toast.error(error?.message);
        }
      }
    }
  };

  const withdrawHandler = async () => {
    if (!account) {
      toast.error("Error! please connect your wallet");
    } else {
      try {
        setloading(true);
        let tx = await stakingContract.withdrawunstake();
        await tx.wait();
        toast.success("Success! Transection completed. ");
        setloading(false);
      } catch (error) {
        setloading(false);
        if (error?.data?.message) {
          toast.error(error?.data?.message);
        } else {
          toast.error(error?.message);
        }
      }
    }
  };

  // const Title = () => (
  //   <>
  //     <Box
  //       width="100%"
  //       display="flex"
  //       flexDirection="column"
  //       alignItems="center"
  //     >
  //       <Box fontSize="12px" color="#ffffff" fontWeight="400px">
  //         This calculation includes both Galaxy and WETH earned through staking
  //         Galaxy.
  //       </Box>
  //       <Divider
  //         style={{
  //           backgroundColor: "#fff",
  //           opacity: "0.7",
  //           width: "100%",
  //           height: "0.5px",
  //           marginTop: "15px",
  //         }}
  //       />
  //       <Box
  //         mt={2}
  //         display="flex"
  //         alignItems="center"
  //         justifyContent="space-between"
  //         width="100%"
  //       >
  //         <Box
  //           fontSize="12px"
  //           color="#fff"
  //           fontWeight="500"
  //           style={{ opacity: "0.4" }}
  //         >
  //           Current Galaxy
  //         </Box>
  //         <Box
  //           fontSize="12px"
  //           color="#fff"
  //           fontWeight="500"
  //           style={{ opacity: "0.7" }}
  //         >
  //           210.5%
  //         </Box>
  //       </Box>
  //       <Divider
  //         style={{
  //           backgroundColor: "#fff",
  //           opacity: "0.7",
  //           width: "100%",
  //           height: "0.5px",
  //           marginTop: "15px",
  //         }}
  //       />
  //       <Box
  //         mt={2}
  //         display="flex"
  //         alignItems="center"
  //         justifyContent="space-between"
  //         width="100%"
  //       >
  //         <Box
  //           fontSize="12px"
  //           color="#fff"
  //           fontWeight="500"
  //           style={{ opacity: "0.4" }}
  //         >
  //           Current BNB
  //         </Box>
  //         <Box
  //           fontSize="12px"
  //           color="#fff"
  //           fontWeight="500"
  //           style={{ opacity: "0.7" }}
  //         >
  //           450.5%
  //         </Box>
  //       </Box>
  //       <Box mt={2} fontSize="12px" color="#ffffff" fontWeight="400px">
  //         Lorem Ipsum is simply dummy text of the printing and typesetting
  //         industry. <br />
  //         <br /> Lorem Ipsum has been the industry's standard dummy text ever
  //         since the 1500s, when an unknown printer took a galley of type and
  //         scrambled it to make a type specimen book.
  //       </Box>
  //     </Box>
  //   </>
  // );

  return (
    <>
      {" "}
      <Loader loading={loading} />
      <Box mt={10}>
        <Grid container spacing={5}>
          <Grid item xs={12} sm={6}>
            <Stack alignItems="center" flexDirection="row">
              <Box mr={1}>
                <img src={logo} width="100px" height="100px" alt="Galaxy" />
              </Box>
              <Stack>
                <Box
                  fontSize="25px"
                  color="#fff"
                  fontWeight="600"
                  style={{ opacity: "0.9" }}
                  fontFamily="Raleway"
                  // ml={2}
                >
                  Get Galaxy
                </Box>
                <Box
                  mt={1}
                  textAlign="center"
                  fontSize="15px"
                  color="#fff"
                  fontWeight="500"
                  fontFamily="Raleway"
                  px={4}
                  py={2}
                  borderRadius="25px"
                  style={{
                    cursor: "pointer",
                    background: "linear-gradient(360deg, #26058E 50%, #A301F7)",
                  }}
                >
                  Buy On Pancakeswap{" "}
                  <i
                    style={{
                      marginLeft: "10px",
                      color: "#ffffff",
                      fontSize: "15px",
                      fontWeight: "300",
                    }}
                    className="fal fa-external-link-alt"
                  ></i>
                </Box>
                <Box
                  mt={2}
                  textAlign="left"
                  fontSize="15px"
                  color="#fff"
                  fontWeight="400"
                  fontFamily="Raleway"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  Learn how to buy{" "}
                  <i
                    style={{
                      marginLeft: "10px",
                      color: "#ffffff",
                      fontSize: "15px",
                      fontWeight: "200",
                    }}
                    className="fal fa-external-link-alt"
                  ></i>
                </Box>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Accordion
              style={{
                boxShadow: "rgba(0, 0, 0, 0.35) 0px 0px 15px 5px",
                width: "100%",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    style={{
                      color: "#ffffff",
                      fontSize: "22px",
                      fontWeight: "600",
                    }}
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography fontSize="22px" fontWeight={600}>
                  Your Stake
                </Typography>
              </AccordionSummary>
              <AccordionDetails style={{ width: "100%" }}>
                <Stack width="100%" bgcolor="#271942" p={2}>
                  <Box
                    border="2px solid #ffffff"
                    width="200px"
                    display="flex"
                    alignItems="center"
                  >
                    <Box
                      width="100px"
                      color={index === 0 ? "#ffffff" : "#ffffff"}
                      px={2}
                      paddingTop="3px"
                      paddingBottom="3px"
                      fontWeight="400"
                      fontFamily="Raleway"
                      textAlign="center"
                      onClick={() => setindex(0)}
                      style={{
                        cursor: "pointer",
                        background:
                          index === 0
                            ? "linear-gradient(360deg, #26058E 50%, #A301F7)"
                            : "#001227",
                      }}
                    >
                      Stake
                    </Box>
                    <Box
                      width="100px"
                      color={index === 1 ? "#ffffff" : "#ffffff"}
                      px={2}
                      paddingTop="3px"
                      paddingBottom="3px"
                      textAlign="center"
                      fontWeight="400"
                      fontFamily="Raleway"
                      onClick={() => setindex(1)}
                      style={{
                        cursor: "pointer",
                        background:
                          index === 1
                            ? "linear-gradient(360deg, #26058E 50%, #A301F7)"
                            : "#001227",
                      }}
                    >
                      Unstake
                    </Box>
                  </Box>
                  {index === 0 ? (
                    <Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        height="45px"
                        mt={5}
                      >
                        <input
                          style={{
                            outline: "none",
                            paddingLeft: "7px",
                            color: "#ffffff",
                            background: "none",
                            height: "38px",
                            padding: "4px 11px",
                            fontSize: "14px",
                            lineHeight: "1.5",
                            width: "100%",
                            border: "1px solid #FFFFFF4D",
                            borderRadius: "0px",
                          }}
                          value={amount}
                          onChange={(e) => setamount(e.target.value)}
                          step="0.5"
                          type="number"
                          placeholder="0"
                        />
                        <Box
                          textAlign="center"
                          width="100px"
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          bgcolor="#DB162F"
                          style={{
                            cursor: "pointer",
                            background:
                              "linear-gradient(360deg, #26058E 50%, #A301F7)",
                          }}
                        >
                          <Button
                            style={{ color: "#fff" }}
                            onClick={() => stakeHandler()}
                          >
                            Stake
                          </Button>
                        </Box>
                      </Box>
                      <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          style={{ opacity: "0.7" }}
                        >
                          Galaxy in wallet:
                        </Box>
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Open Sans"
                          style={{ opacity: "0.7" }}
                        >
                          {balance}
                        </Box>
                      </Box>
                      <Box
                        mt={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          style={{ opacity: "0.7" }}
                        >
                          Your Stake (Compounding):
                        </Box>
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Open Sans"
                          style={{ opacity: "0.7" }}
                        >
                          {totalStakedAmount}
                        </Box>
                      </Box>
                      <Box
                        mt={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          style={{ opacity: "0.7" }}
                        >
                          Current Tire:
                        </Box>
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Open Sans"
                          style={{ opacity: "0.7" }}
                        >
                          {currentTire}
                        </Box>
                      </Box>
                      <Box
                        mt={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          style={{ opacity: "0.7" }}
                        >
                          Stake Count:
                        </Box>
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Open Sans"
                          style={{ opacity: "0.7" }}
                        >
                          {stakeCount}
                        </Box>
                      </Box>
                      <Divider
                        style={{
                          backgroundColor: "#fff",
                          opacity: "0.7",
                          width: "100%",
                          height: "1px",
                          marginTop: "30px",
                        }}
                      />
                    </Box>
                  ) : (
                    <Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        height="45px"
                        mt={5}
                      >
                        <Box
                          textAlign="center"
                          width="100px"
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          bgcolor="#DB162F"
                          px={2}
                          py={1}
                          style={{
                            cursor: "pointer",
                            background:
                              "linear-gradient(360deg, #26058E 50%, #A301F7)",
                          }}
                          onClick={() => withdrawHandler()}
                        >
                          Witdraw
                        </Box>
                        <Box
                          textAlign="center"
                          width="100px"
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          bgcolor="#DB162F"
                          fontFamily="Raleway"
                          px={2}
                          py={1}
                          style={{
                            cursor: "pointer",
                            background:
                              "linear-gradient(360deg, #26058E 50%, #A301F7)",
                          }}
                          onClick={() => unStakeHandler()}
                        >
                          Unstake
                        </Box>
                      </Box>
                      <Box
                        mt={2}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          style={{ opacity: "0.7" }}
                        >
                          Galaxy in wallet:
                        </Box>
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Open Sans"
                          style={{ opacity: "0.7" }}
                        >
                          {balance}
                        </Box>
                      </Box>
                      <Box
                        mt={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          style={{ opacity: "0.7" }}
                        >
                          Your Stake (Compounding):
                        </Box>
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Open Sans"
                          style={{ opacity: "0.7" }}
                        >
                          {totalStakedAmount}
                        </Box>
                      </Box>
                      <Box
                        mt={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          style={{ opacity: "0.7" }}
                        >
                          Current Tire:
                        </Box>
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Open Sane"
                          style={{ opacity: "0.7" }}
                        >
                          {currentTire}
                        </Box>
                      </Box>
                      <Box
                        mt={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Raleway"
                          style={{ opacity: "0.7" }}
                        >
                          Stake Count:
                        </Box>
                        <Box
                          fontSize="15px"
                          color="#fff"
                          fontWeight="400"
                          fontFamily="Open Sans"
                          style={{ opacity: "0.7" }}
                        >
                          {stakeCount}
                        </Box>
                      </Box>
                      <Divider
                        style={{
                          backgroundColor: "#fff",
                          opacity: "0.7",
                          width: "100%",
                          height: "1px",
                          marginTop: "30px",
                        }}
                      />
                    </Box>
                  )}
                </Stack>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
